import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const SequencerScale = (props) => { 
    return (
        <div className="sequencer-scale">
          Scale:
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SequencerScale);
